/* Sail Workshop — anında fiyat güncellemesi
   Dawn seçenek değişiminde bölümü sunucudan yeniden çeker (~1 sn).
   Bu kod, gömülü varyant haritasından fiyatı ve buton durumunu hemen günceller;
   sunucu yanıtı geldiğinde zaten aynı değerlerle üzerine yazar. */
(function () {
  function parseMap(root) {
    var el = root.querySelector('script[data-sw-variants]');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  function selectedKey(root) {
    var parts = [];
    root.querySelectorAll('fieldset, .product-form__input').forEach(function (f) {
      var r = f.querySelector('input[type="radio"]:checked');
      if (r) { parts.push(r.value); return; }
      var s = f.querySelector('select');
      if (s) parts.push(s.value);
    });
    return parts.join('~~');
  }

  function apply(info, v) {
    var price = info.querySelector('.price');
    if (price) {
      price.classList.toggle('price--on-sale', !!v.h);
      price.classList.toggle('price--sold-out', !v.a);
      var sale = price.querySelector('.price-item--sale');
      if (sale) sale.textContent = v.p;
      price.querySelectorAll('s.price-item--regular').forEach(function (n) {
        n.textContent = v.c;
      });
      if (!sale) {
        var reg = price.querySelector('.price-item--regular:not(s)');
        if (reg) reg.textContent = v.p;
      }
    }
    var btn = info.querySelector('[name="add"]');
    if (btn) {
      var txt = btn.querySelector('span');
      btn.disabled = !v.a;
      if (txt && !v.a) txt.textContent = btn.dataset.swSold || txt.textContent;
    }
  }

  document.addEventListener('change', function (e) {
    var root = e.target && e.target.closest && e.target.closest('variant-selects');
    if (!root) return;
    var info = root.closest('product-info') || document;
    var map = parseMap(root);
    if (!map) return;
    var key = selectedKey(root);
    for (var i = 0; i < map.length; i++) {
      if (map[i].k === key) { apply(info, map[i]); return; }
    }
  }, true);
})();
